import React from 'react'
import Filter from './Filter'
import FilterRelevance from './FilterRelevance'



function FilterComponent() {
  return (
    <div className="min-h-screen flex gap-10 p-12">
    {/* Left Side - Filter (1/3 width) */}
    <div className="w-1/4">
      <Filter />
    </div>

    <div className="w-3/4">
   <FilterRelevance/>
    </div>
  </div>
  )
}; 

export default FilterComponent